import { render, staticRenderFns } from "./BrevoNewsletterForm.vue?vue&type=template&id=681eddb9"
import script from "./BrevoNewsletterForm.vue?vue&type=script&lang=js"
export * from "./BrevoNewsletterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports